import React from 'react';
import { useLanguage } from '../i18n';

export default function RefundPage() {
  const { t } = useLanguage();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: '48rem', margin: '0 auto', backgroundColor: '#FFFFFF', borderRadius: '1rem', padding: '3rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: '800', color: '#1A1A1A', marginBottom: '0.5rem' }}>Refund Policy</h1>
          <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Last updated: May 2026 · Veyl</p>
        </div>

        {/* Translation Notice */}
        <div style={{
          backgroundColor: 'rgba(27,122,138,0.08)',
          border: '1px solid #1B7A8A',
          borderRadius: '0.5rem',
          padding: '1rem',
          marginBottom: '2rem',
          fontSize: '0.875rem',
          color: '#1B7A8A'
        }}>
          🌐 {t('legalEnglishOnly')}
        </div>

        {/* Intro */}
        <p style={{ color: '#4b5563', lineHeight: '1.8', fontSize: '0.95rem', marginBottom: '2rem' }}>
          Thank you for subscribing to Veyl. We want to be transparent about our refund policy so you can make informed decisions about your subscription.
        </p>

        {[
          {
            title: '1. 48-Hour Cancellation Window',
            content: `If you are not satisfied with your purchase, you may request a full refund within 48 hours of your initial subscription payment. To request a refund, contact us at support@veyl.space within this window and we will process your refund promptly.`
          },
          {
            title: '2. No Refunds After 48 Hours',
            content: `After the 48-hour cancellation window has passed, all payments are final and non-refundable. This applies to both monthly and 6-month subscription plans. You will continue to have access to your premium features until the end of your current billing period.`
          },
          {
            title: '3. Cancellations',
            content: `You may cancel your subscription at any time from the Settings page within the app. Cancellation stops future charges but does not entitle you to a refund for the current billing period.`
          },
          {
            title: '4. Exceptions',
            content: `We may consider refunds outside the 48-hour window on a case-by-case basis for exceptional circumstances such as technical issues that prevented access to the service. Contact support@veyl.space to discuss your situation.`
          },
          {
            title: '5. Contact',
            content: `For any refund requests or questions, email us at support@veyl.space. We typically respond within 1-2 business days.`
          },
        ].map(section => (
          <div key={section.title} style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1A1A1A', marginBottom: '0.75rem' }}>
              {section.title}
            </h2>
            <p style={{ color: '#4b5563', lineHeight: '1.8', fontSize: '0.95rem' }}>
              {section.content}
            </p>
          </div>
        ))}

        <div style={{ marginTop: '3rem', paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb', textAlign: 'center' }}>
          <a href="/" style={{ color: '#1B7A8A', textDecoration: 'none', fontWeight: '600', fontSize: '0.9rem' }}>← Back to Veyl</a>
        </div>
      </div>
    </div>
  );
}